import React from 'react';
import { Global } from '@emotion/react';

const GlobalStyle = () => {
  return (
    <Global
      styles={() => [
        {
          '@font-face': {
            fontFamily: 'Muli',
            src: `local(Muli-Regular), url('https://common-assets.srv.connectedcare.io/cc-common-assets/fonts/Muli/Muli-Regular.ttf') format("truetype")`,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            fontDisplay: 'swap',
          },
        },
        {
          '@font-face': {
            fontFamily: 'Muli',
            src: `local(Muli-Bold), url('https://common-assets.srv.connectedcare.io/cc-common-assets/fonts/Muli/Muli-Bold.ttf') format("truetype")`,
            fontWeight: 'bold',
            fontStyle: 'normal',
            fontStretch: 'normal',
            fontDisplay: 'swap',
          },
        },
      ]}
    />
  );
};

export default GlobalStyle;
